import { useApolloClient, useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { SIGN_OUT } from '@/graphql/mutations/auth';
import { ROUTES } from '@/shared/config/routes';
import { resetIdentity } from '@/shared/lib/analytics';

type UseSignOutResult = { signOut: () => Promise<void>; isSigningOut: boolean };

export function useSignOut(): UseSignOutResult {
  const client = useApolloClient();
  const navigate = useNavigate();
  const [mutate, { loading }] = useMutation(SIGN_OUT);

  const signOut = useCallback(async () => {
    try {
      await mutate();
    } finally {
      await client.clearStore();
      resetIdentity();
      navigate(ROUTES.SIGN_IN, { replace: true });
    }
  }, [client, mutate, navigate]);

  return { signOut, isSigningOut: loading };
}
